import installer from './defaults'
export * from '@sgui-plus/components'
export * from '@sgui-plus/directives'
export * from '@sgui-plus/hooks'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer
